module.exports = __webpack_public_path__ + "static/media/family-m-1.d02452d7.png";